import { render } from "./DiscoveryDetailsModal.vue?vue&type=template&id=1407a5b4&scoped=true"
import script from "./DiscoveryDetailsModal.vue?vue&type=script&lang=js"
export * from "./DiscoveryDetailsModal.vue?vue&type=script&lang=js"

import "./DiscoveryDetailsModal.vue?vue&type=style&index=0&id=1407a5b4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1407a5b4"]])

export default __exports__